export const roundedUi = {
    name: "RoundedUI",
    variants: [
        ["Control", 1],
        ["Test", 1],
    ],
    controlVariant: "Control",
    apply: ({ assignVariant, clearVariant, getVariant, isParticipatingInOtherTests, }) => {
        var _a;
        const isMobileApp = Skubacz.Device.isMobileApp();
        const isValidTheme = ["fiesta", "new_vision"].includes(Skubacz.configuration.theme_name);
        const isEnabled = ((_a = Skubacz.configuration.feature_flags) === null || _a === void 0 ? void 0 : _a.rounded_ui_ab_test_enabled) === true;
        const isInOtherTest = isParticipatingInOtherTests();
        if (isMobileApp || !isValidTheme || !isEnabled || isInOtherTest) {
            clearVariant();
            return;
        }
        const variant = Skubacz.configuration.environment === "systemtest"
            ? getVariant()
            : assignVariant();
        if (variant === "Test") {
            const applyClass = () => document.body.classList.add("body--rounded");
            if (document.readyState === "loading") {
                document.addEventListener("DOMContentLoaded", applyClass, {
                    once: true,
                });
            }
            else {
                applyClass();
            }
        }
    },
};
